"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimePartition = getTimePartition;
exports.timeToMs = timeToMs;
/**
 * Partitions time into windows and returns the number of windows between startTime and testTime.
 * This is useful for cases where we want a deterministic response for times in the same window (e.g 1 hour), such as a time-throttle in a dedup key
 * @param timeWindowSize The unit of time (ms) used to determine how to partition time into windows
 * @param startTime The start time (ms) of the first window - where we start counting from
 * @param testTime The time (ms) we want to get the window number for
 * @returns the number of "time windows" between startTime and testTime
 */
function getTimePartition(timeWindowSize, startTime = 0, testTime = new Date().getTime()) {
    const gap = testTime - startTime;
    const windowNumber = Math.floor(gap / timeWindowSize);
    return windowNumber;
}
/**
 * @deprecated - Use convertToMs from @engineering11/date-time
 * @param milli
 * @param seconds
 * @param minutes
 * @param hours
 * @param days
 * @param weeks
 */
function timeToMs(milli = 0, seconds = 0, minutes = 0, hours = 0, days = 0, weeks = 0) {
    let totalMilliseconds = 0;
    totalMilliseconds += milli;
    totalMilliseconds += seconds * 1000;
    totalMilliseconds += minutes * 60 * 1000;
    totalMilliseconds += hours * 60 * 60 * 1000;
    totalMilliseconds += days * 24 * 60 * 60 * 1000;
    totalMilliseconds += weeks * 7 * 24 * 60 * 60 * 1000;
    return totalMilliseconds;
}
